/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @flow */

import React from 'react';
import Figure from '../Figure';
import FigCaption from '../FigCaption';
import FigContainer from '../FigContainer';
import CategoryHeader from '../CategoryHeader';

/* eslint-disable prettier/prettier */
import IconAddAlert from '../../../../../../Icon/IconAddAlert';
import IconError from '../../../../../../Icon/IconError';
import IconErrorOutline from '../../../../../../Icon/IconErrorOutline';
import IconWarning from '../../../../../../Icon/IconWarning';

export default function AlertIcons() {
  return (
    <div>
      <CategoryHeader>alert</CategoryHeader>
      <FigContainer>
        <Figure tabIndex={0}>
          <IconAddAlert size="32"/>
          <FigCaption>
            IconAddAlert
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconError size="32"/>
          <FigCaption>
            IconError
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconErrorOutline size="32"/>
          <FigCaption>
            IconErrorOutline
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconWarning size="32"/>
          <FigCaption>
            IconWarning
          </FigCaption>
        </Figure>
      </FigContainer>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/website/app/demos/Icon/components/categories/AlertIcons.js